
(function() {
  'use strict';
  
  if (window.innerWidth > 768) return;
  
  // Cache DOM elements (V8 Selectors)
  const stage = document.getElementById('v8Stage');
  const housing = document.getElementById('v8Housing');
  const fill = document.getElementById('v8Fill');
  const knob = document.getElementById('v8Knob');
  const moon = document.getElementById('v8Moon');
  const chevronsContainer = document.getElementById('v8Chevrons');
  const chevrons = chevronsContainer ? Array.from(chevronsContainer.querySelectorAll('.svasti-v8-chevron')) : [];
  const cards = stage ? Array.from(stage.querySelectorAll('.svasti-v8__card')) : [];
  
  const count = cards.length;
  if (!housing || !knob || !moon || count === 0) return;
  
  // =============================================
  // CHEVRON ANIMATION (V7 Reference)
  // =============================================
  const WINDOW_SIZE = 5;
  const CHEVRON_COUNT = chevrons.length;
  let chevronAnimationId = null;
  let chevronStartTime = null;
  const CHEVRON_DURATION = 6500;
  const STEP_INTERVAL = 230;
  const FADE_OUT_MS = 1300;
  function updateChevrons(timestamp) {
    if (!chevronStartTime) chevronStartTime = timestamp;
    const elapsed = timestamp - chevronStartTime;
    if (elapsed >= CHEVRON_DURATION - FADE_OUT_MS) {
      chevronsContainer.classList.add('fade-out');
    }
    if (elapsed >= CHEVRON_DURATION) {
      chevrons.forEach(c => c.classList.remove('lit'));
      return;
    }
    const totalSteps = CHEVRON_COUNT + WINDOW_SIZE;
    const rawStep = Math.floor(elapsed / STEP_INTERVAL);
    const step = rawStep % totalSteps;
    chevrons.forEach((chevron, i) => {
      const headPos = Math.max(0, step - WINDOW_SIZE + 1);
      const tailPos = step;
      if (i >= headPos && i <= tailPos && i < CHEVRON_COUNT) chevron.classList.add('lit');
      else chevron.classList.remove('lit');
    });
    chevronAnimationId = requestAnimationFrame(updateChevrons);
  }
  if (chevrons.length > 0) {
    chevronAnimationId = requestAnimationFrame(updateChevrons);
  }
  // =============================================
  // SLIDER LOGIC (V7 PRECISE PORT)
  // =============================================
  // Moon URLs
  const moonUrls = [];
  const baseSrc = moon.src;
  for (let i = 1; i <= 9; i++) {
    moonUrls.push(baseSrc.replace(/Phase_\d+_clean\.svg/, `Phase_${i}_clean.svg`));
  }
  // State
  let progress = 0;
  let targetProgress = 0;
  let lastPhase = 1;
  let lastHapticIndex = -1;
  let drag = { active: false, started: false, startY: 0 };
  const TICK_INSET = 12;
  
  // Cached Metrics (V8 Optimization)
  let housingRect = { top: 0, height: 400 };
  let knobHalf = 17;
  let topLimit = 0;
  let bottomLimit = 0;
  let travelRange = 1;
  function updateMetrics() {
    housingRect = housing.getBoundingClientRect();
    const h = housingRect.height;
    knobHalf = knob.offsetHeight / 2;
    // Nudged top limit up by 4px to cover notch improved visual alignment
    topLimit = TICK_INSET + knobHalf - 4;
    bottomLimit = h - TICK_INSET - knobHalf;
    travelRange = bottomLimit - topLimit;
  }
  updateMetrics();
  window.addEventListener('resize', updateMetrics);
  function clamp01(v) {
    return Math.max(0, Math.min(1, v));
  }
  function snapToNotch(val01) {
    if (count === 1) return { idx: 0, snapped: 0 };
    const idx = Math.round(val01 * (count - 1));
    return { idx, snapped: idx / (count - 1) };
  }
  // V7 EXACT CARD PHYSICS
  function computeTransform(dist) {
    const absDist = Math.abs(dist);
    // V7 Reference Values: Tighter stack, smoother falloff
    if (absDist > 2.2) {
      return {
        y: dist * 86, // Tighter (was 235)
        scale: 0.84,
        opacity: 0, 
        z: -60,
        blur: 0,
        brightness: 0.55
      };
    }
    return {
      y: dist * 86, // Tighter (was 235)
      scale: Math.max(0.88, 1 - absDist * 0.06),
      opacity: Math.max(0.28, 1 - absDist * 0.42),
      z: -absDist * 26,
      blur: Math.min(7, absDist * 4.4),
      brightness: Math.max(0.72, 1 - absDist * 0.22)
    };
  }
  function setMoonPhase(phaseNum) {
    if (phaseNum === lastPhase) return;
    lastPhase = phaseNum;
    moon.src = moonUrls[phaseNum - 1];
    moon.dataset.phase = phaseNum;
  }
  function updateVisuals(pct) {
    // 1. Knob
    const topPx = topLimit + (pct * travelRange);
    knob.style.transform = `translate(-50%, -50%) translateY(${topPx}px)`; 
    knob.style.top = '0';
    knob.style.left = '50%';
    fill.style.height = `${pct * 100}%`;
    
    // 2. Cards
    const activeIndex = pct * (count - 1);
    const notch = Math.round(activeIndex);
    
    setMoonPhase(notch + 1);
    
    // Haptics
    if (notch !== lastHapticIndex) {
      if (navigator.vibrate) navigator.vibrate(10); // V7 was 10ms
      lastHapticIndex = notch;
    }
    cards.forEach((card, i) => {
        const dist = i - activeIndex;
        // V7: "Softer cutoff"
        if (Math.abs(dist) > 2.5) { // Slightly wider render culling for safety
             card.style.display = 'none';
        } else {
             card.style.display = 'block';
             const t = computeTransform(dist);
             // V7 had translate3d(-10px...)? Keeping 0 for center alignment in V8 layout
             card.style.transform = `translate3d(0, ${t.y}px, ${t.z}px) scale(${t.scale})`;
             card.style.opacity = t.opacity;
             card.style.filter = `blur(${t.blur}px) brightness(${t.brightness})`;
             card.style.zIndex = Math.round(100 - Math.abs(dist) * 10);
             card.style.pointerEvents = Math.abs(dist) < 0.55 ? 'auto' : 'none';
        }
    });
  }
  function handleInput(clientY) {
    let y = clientY - housingRect.top;
    y = Math.max(topLimit, Math.min(bottomLimit, y));
    const val = (y - topLimit) / travelRange;
    // V7: Snap WHILE dragging
    targetProgress = snapToNotch(clamp01(val)).snapped;
  }
  function tick() {
    // V7 Reference Factors
    const follow = (drag.active && drag.started) ? 0.34 : 0.18;
    
    progress += (targetProgress - progress) * follow;
    progress = clamp01(progress);
    updateVisuals(progress);
    
    requestAnimationFrame(tick);
  }
  function onStart(e) {
    const t = e.touches ? e.touches[0] : e;
    drag.active = true;
    drag.started = false;
    drag.startY = t.clientY;
    updateMetrics(); 
    e.preventDefault();
  }
  function onMove(e) {
    if (!drag.active) return;
    const t = e.touches ? e.touches[0] : e;
    const dy = t.clientY - drag.startY;
    if (!drag.started) {
      if (Math.abs(dy) < 7) return; // V7 was 7
      drag.started = true;
    }
    e.preventDefault();
    handleInput(t.clientY);
  }
  function onEnd() {
    drag.active = false;
    drag.started = false;
  }
  knob.addEventListener('touchstart', onStart, { passive: false });
  document.addEventListener('touchmove', onMove, { passive: false });
  document.addEventListener('touchend', onEnd);
  
  // Init
  updateVisuals(0);
  tick();
})();
